import type { ResolvedLinkProps } from "types/storyblok.d";

const getUrlFromLink = (link: ResolvedLinkProps): string => {
  const storyFullSlug = link?.story?.full_slug;
  const storyLink = storyFullSlug ? `/${storyFullSlug}` : "";

  return storyLink || link?.url;
};

export default getUrlFromLink;
